import { render } from "./CommentForm.vue?vue&type=template&id=7756fbb6&scoped=true"
import script from "./CommentForm.vue?vue&type=script&lang=js"
export * from "./CommentForm.vue?vue&type=script&lang=js"

import "./CommentForm.vue?vue&type=style&index=0&id=7756fbb6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7756fbb6"]])

export default __exports__